import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ProfileDropdownn from "./ProfileDropdownn";
import { useCart } from "./CartContext";
import { toast } from "react-toastify";
import { License } from "types";
import CartDropdown from "./cart/CartDropdown";
import logo from "../assets/images/RealEsy_V01.svg";

import { getAuthCookie } from "../utils/authCookies";
const SignageTeammemberHeader = () => {
  const userName = getAuthCookie("userName");
  const userType = getAuthCookie("userType");
  const token = getAuthCookie("sessionToken");
  const [loading, setLoading] = useState(true);
  const cartDropdownRef = useRef<HTMLDivElement>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const userId = getAuthCookie("userId");
  const { fetchCart } = useCart();
  const [license, setLicense] = useState<License | null>(null);
  const [error, setError] = useState<string>("");
  const licenseType = getAuthCookie("licenseType");

  useEffect(() => {
    fetchCart();
  }, []);

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/users/${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch license data");
        }

        const data = await response.json();
        if (data) {
          setLicense(data);
        }

      } catch (error) {
        console.error("Error fetching license data:", error);
        setError("Failed to fetch license data.");
      } finally {
        setLoading(false);
      }
    };

    if (!license) {
      fetchLicense();
    }
  }, [userId, license, token]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cartDropdownRef.current &&
        !cartDropdownRef.current.contains(event.target as Node)
      ) {
        setIsCartOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close sidebar when clicking outside on MOBILE (≤767px)
  useEffect(() => {
    const handleDocClick = (e: MouseEvent) => {
      const isMobile = window.innerWidth <= 767;
      if (!isMobile) return;

      if (document.body.classList.contains("vertical-sidebar-enable")) {
        const target = e.target as Element;
        const insideSidebar = target.closest(".app-menu");
        if (!insideSidebar) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.body.classList.remove("sidebar-enable");
        }
      }
    };

    document.addEventListener("mousedown", handleDocClick);
    return () => document.removeEventListener("mousedown", handleDocClick);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.body.classList.remove("sidebar-enable");
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);


  const handleRemoveProduct = async (productId: string, variantId: string) => {
    try {
      setLoading(true);

      const token = getAuthCookie("sessionToken");
      const cartId = localStorage.getItem("cart_id");

      if (!token || !cartId) {
        console.error("Missing token or cartId");
        setLoading(false);
        return;
      }
      console.log("productId :", productId)
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/carts/${cartId}/products/${productId}/variants/${variantId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete product");
      }

      await fetchCart(); // Refresh the cart items
      toast.success("Product removed successfully!");
    } catch (err) {
      toast.error("Failed to remove product");
    } finally {
      setLoading(false);
    }
  };

  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="17" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm p-0 fs-20 header-item d-inline-flex d-md-none"
              onClick={() => {
                document.body.classList.add("vertical-sidebar-enable");
              }}
              aria-label="Open sidebar"
            >
              <i className="ri-menu-2-line"></i>
            </button>
          </div>

          <div className="d-flex align-items-center">
            <div className="dropdown d-md-none topbar-head-dropdown header-item">
              <button
                type="button"
                className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-search fs-22"></i>
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <button className="btn btn-primary" type="submit">
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {licenseType !== null && licenseType === "BROKERAGE_TEAM_MEMBER" && (
              <CartDropdown base="teammember" />
            )}
            <ProfileDropdownn
              name={userName || "Guest"}
              role={userType || "Team member"}
              imageUrl={license?.profilePic || ""}
              login="signageteammember"
              token={token || ""}
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default SignageTeammemberHeader;